import store from 'store'
import { LOCAL_STORAGE_AUTH_KEY, PRE_SIGNUP_SUBSCRIPTION_KEY, POST_SIGNUP_SUBSCRIPTION_KEY } from '../config/constants'
import { errorNotification } from './helpers'

export const authorizeHeader = (config, idTokenRequired = false, isAuth0Management = false) => {
  // const token = 'Bearer ' + store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN) + ' ' + store.get(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN)
  const accessToken = store.get((isAuth0Management) ? LOCAL_STORAGE_AUTH_KEY.MGMT_ACCESS_TOKEN : LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
  const idToken = store.get((isAuth0Management) ? LOCAL_STORAGE_AUTH_KEY.MGMT_ID_TOKEN : LOCAL_STORAGE_AUTH_KEY.ID_TOKEN)
  try{
  if(!accessToken){
    throw new Error();
  }
  let token = 'Bearer ' + accessToken
  token += (idTokenRequired) ? (' ' + idToken) : ''
  if (config && config.headers) {
    config.headers['Authorization'] = token
    config.headers['Ocp-Apim-Subscription-Key'] = POST_SIGNUP_SUBSCRIPTION_KEY
  } else {
    config['headers'] = {
      'Authorization': 'JWT ' + token,
      'Ocp-Apim-Subscription-Key': POST_SIGNUP_SUBSCRIPTION_KEY
    }
  }
  return config
  }
  catch (e) {
    errorNotification('Acccess token is not available. Please try again.')
  }

}

export const configureHeaderForEmailVerification = (config) => {
  if (config && config.headers) {
    config.headers['Ocp-Apim-Subscription-Key'] = PRE_SIGNUP_SUBSCRIPTION_KEY
  } else {
    config['headers'] = {
      'Ocp-Apim-Subscription-Key': PRE_SIGNUP_SUBSCRIPTION_KEY
    }
  }
  return config
}
